var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.20926H22V10.2093H16.5C16.825 10.9843 17 11.8143 17 12.7093C17 16.3143 14.105 19.2093 10.5 19.2093C6.9 19.2093 4 16.3143 4 12.7093M10.5 6.20926C6.895 6.20926 4 9.10426 4 12.7093M10.5 6.20926V9.20926M4 12.7093H2",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainers);
export default __webpack_public_path__ + "static/media/trainers.df5a8e324df20c84ba9a8b1b039287e0.svg";
export { ForwardRef as ReactComponent };